import { isPathRegex } from './path.tools'

export const getSelectButtonClass = (
  selected: boolean,
  theme: string
): string => {
  const defaultClass = ` fw-bold`
  const selectedClass = `bg-input bg-dark-subtle text-${theme === 'dark' ? 'light' : 'dark'} opacity-100`
  const notSelectedClass = `bg-light-subtle text-${theme === 'dark' ? 'light' : 'dark'}`
  return defaultClass + ' ' + (selected ? selectedClass : notSelectedClass)
}

export const getLinkClasses = (
  path: string,
  theme: string,
  pathname: string
): string => {
  const defaultClasses = `mt-2 nav-link text-${theme === 'dark' ? 'light' : 'dark'} fw-bold rounded-top d-flex align-items-center px-5`
  const linkActiveClasses = defaultClasses + ' ' + 'bg-light-subtle'
  const linkPassiveClasses = defaultClasses + ' ' + 'bg-dark-subtle'
  if (path == '') {
    return pathname == '/' ? linkActiveClasses : linkPassiveClasses
  } else {
    return isPathRegex(pathname, new RegExp(`${path}.*$`))
      ? linkActiveClasses
      : linkPassiveClasses
  }
}
